import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import AppLogo from 'library/appLogo';

class LoginOptions extends React.Component {
  static propTypes = {
    visible: PropTypes.bool,
    onOptionClick: PropTypes.func
  };

  static defaultProps = {
    visible: true,
    onOptionClick() {
    }
  };

  constructor(props) {
    super(props);
    this.handleOptionClick = this.handleOptionClick.bind(this);
  }

  handleOptionClick(value) {
    const { onOptionClick } = this.props;
    onOptionClick(value);
  }

  render() {
    const { visible } = this.props;

    return (
      <div className={`bhp-login-panel ${visible ? 'bhp-rotateSlideIn' : 'bhp-rotateSlideOut'}`}>
        <div className="bhp-header">
          <AppLogo />
        </div>
        <div className="bhp-content">
          <div className="bhp-title-2 bhp-margin-bottom-1x">Crew Rostering</div>
          <div className="bhp-login-option bhp-margin-bottom-4x">Select your login option:</div>
          <div className="bhp-button-container">
            <Button type="primary" htmlType="submit" onClick={() => this.handleOptionClick('msal')}>
              APAC User
            </Button>

          </div>
        </div>
      </div>
    );
  }
}

export default LoginOptions;
